module.exports = __webpack_public_path__ + "static/media/dash.d2f37622.svg";